import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

// O React Router numera as entradas do histórico em `history.state.idx`. Quando é 0 — ou nem
// existe, no caso de quem abriu a URL direto (link externo, favorito, e-mail de reset) — esta é a
// primeira entrada da sessão e `navigate(-1)` jogaria a pessoa para fora do app.
export function useBackNavigation(fallbackTo = '/'): () => void {
  const navigate = useNavigate()

  return useCallback(() => {
    const historyIndex = (window.history.state as { idx?: number } | null)?.idx ?? 0

    if (historyIndex > 0) {
      void navigate(-1)
      return
    }

    void navigate(fallbackTo, { replace: true })
  }, [navigate, fallbackTo])
}
